<template>
  <v-row class="flex-wrap">
    <v-col cols="12" md="6">
      <v-menu
        ref="fromPicker"
        :close-on-content-click="false"
        :nudge-right="33"
        :return-value.sync="from"
        :menu-props="{transition:'slide-y-transition'}"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            v-model="from"
            label="From"
            prepend-icon="event"
            readonly
            filled
            hide-details
            :clearable="clearable"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="from"
          @input="$refs.fromPicker.save(from)"
          :disabled="disabled"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="12" md="6">
      <v-menu
        ref="toPicker"
        :close-on-content-click="false"
        :nudge-right="33"
        :return-value.sync="to"
        :menu-props="{transition:'slide-y-transition'}"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            v-model="to"
            label="To"
            prepend-icon="event"
            readonly
            filled
            hide-details
            :clearable="clearable"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="to"
          @input="$refs.toPicker.save(to)"
          :disabled="disabled"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment-timezone'
  export default {
    props: {
      dateFrom: Number,
      dateTo: Number,
      disabled: Boolean,
      clearable: Boolean,
    },

    data () {
      return {
        from: this.dateFrom ? moment.unix(this.dateFrom).format('YYYY-MM-DD') : null,
        to: this.dateTo ? moment.unix(this.dateTo).format('YYYY-MM-DD') : null
      }
    },

    watch: {
      from: {
        handler (val) {
          this.$emit('updateFrom', moment(val).unix())
        }
      },
      to: {
        handler (val) {
          this.$emit('updateTo', moment(val).unix())
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/DateSelector.vue